import React, { useState, useEffect, useRef } from "react";

import { Divider, Typography, TextField, Paper } from "@mui/material";

import Grid from "@mui/material/Unstable_Grid2";

import moment from "moment";

export default function DailyReport({
  data,
  dataHospitals,
  selectedHospitals,
  selectedHospitalsOfOrigins,
  selectedWards,
  fromDate,
  toDate,
  isNEWSSelected,
  isWaterlowSelected,
  isMMSESelected,
  isFrailtySelected,
  isBarthelSelected,
  isMUSTSelected,
  isNotesSelected,
  isPlansSelected,
  ...props
}) {
  const [dataGrouped, setDataGrouped] = useState([]);

  console.log("data:", data);
  console.log("dataHospitals:", dataHospitals);
  console.log("selectedHospitals:", selectedHospitals);
  console.log("selectedHospitalsOfOrigins:", selectedHospitalsOfOrigins);
  console.log("selectedWards:", selectedWards);

  useEffect(() => {
    if (isNullOrEmpty(selectedWards)) {
      const filteredData =
        selectedHospitalsOfOrigins.length > 0
          ? data.filter((patient) =>
              selectedHospitalsOfOrigins.includes(patient.hospital_of_origin_id)
            )
          : data;

      const groupedData = filteredData.reduce((acc, patient) => {
        const hospitalOfOriginId = patient.hospital_of_origin_id;
        const hospitalOfOriginName = patient.hospital_of_origin_name;

        let group = acc.find((group) => group.id === hospitalOfOriginId);

        if (!group) {
          group = {
            id: hospitalOfOriginId,
            name: hospitalOfOriginName,
            patients: [],
          };
          acc.push(group);
        }

        group.patients.push(patient);

        return acc;
      }, []);

      setDataGrouped(groupedData);
    } else {
      const filteredData =
        selectedWards.length > 0
          ? data.filter((patient) =>
              selectedWards.includes(patient.facility_id)
            )
          : data;

      const groupedData = filteredData.reduce((acc, patient) => {
        const wardId = patient.facility_id;
        const wardName = patient.ward_name;

        let group = acc.find((group) => group.id === wardId);

        if (!group) {
          group = {
            id: wardId,
            name: wardName,
            patients: [],
          };
          acc.push(group);
        }

        group.patients.push(patient);

        return acc;
      }, []);

      setDataGrouped(groupedData);
    }
  }, [data]);

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const formatLabelDate = (value) =>
    new Date(value).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  const generateListItem = (name, patientList) => {
    return (
      <Grid
        container
        spacing={2}
        style={{
          //display: "flex",
          alignItems: "center",
          justifyContent: "center",
          //flexDirection: "column",
        }}
      >
        {patientList !== null && patientList.length > 0 ? (
          <>
            {patientList.map((item, index) => (
              <Grid item xs={12}>
                <Paper
                  key={patientList.patient_id}
                  elevation={2}
                  style={{
                    padding: 20,
                    //width: "calc(100% - 16px)",
                    //border: "1px solid",
                    //borderColor: "#E5E5E6",
                    //borderRadius: 4,
                    //backgroundColor: "#FCFCFC",

                    pageBreakBefore:
                      index % 2 === 0 && index !== 0 ? "always" : "auto",
                  }}
                >
                  <Grid container spacing={2} style={{}}>
                    <Grid item xs={3}>
                      <Typography
                        data-test={"reports-group-item-mrn-title"}
                        variant="subtitle2"
                      >
                        {"MRN"}
                      </Typography>
                      <Typography
                        data-test={"reports-group-item-mrn-value"}
                        variant="body2"
                        style={{ color: "#616161" }}
                      >
                        {isNullOrEmpty(item.mrn) ? "-" : item.mrn}
                      </Typography>
                    </Grid>

                    <Grid item xs={3}>
                      <Typography
                        data-test={"reports-group-item-room-bed-title"}
                        variant="subtitle2"
                      >
                        {"Room/Bed"}
                      </Typography>
                      <Typography
                        data-test={"reports-group-item-room-bed-value"}
                        variant="body2"
                        style={{ color: "#616161" }}
                      >
                        {isNullOrEmpty(item.room_name) ? "-" : item.room_name}
                        {"/"}
                        {isNullOrEmpty(item.bed_name) ? "-" : item.bed_name}
                      </Typography>
                    </Grid>

                    <Grid item xs={3}>
                      <Typography
                        data-test={"reports-group-item-consultant-title"}
                        variant="subtitle2"
                      >
                        {"Consultant"}
                      </Typography>
                      <Typography
                        data-test={"reports-group-item-consultant-value"}
                        variant="body2"
                        style={{ color: "#616161" }}
                      >
                        {isNullOrEmpty(item.consultant) ? "-" : item.consultant}
                      </Typography>
                    </Grid>

                    <Grid item xs={3}>
                      <Typography
                        data-test={"reports-group-item-origin-hospital-title"}
                        variant="subtitle2"
                      >
                        {"Origin Hospital"}
                      </Typography>
                      <Typography
                        data-test={"reports-group-item-origin-hospital-value"}
                        variant="body2"
                        style={{ color: "#616161" }}
                      >
                        {isNullOrEmpty(item.hospital_of_origin_name)
                          ? "-"
                          : item.hospital_of_origin_name}
                      </Typography>
                    </Grid>

                    <Grid item xs={3}>
                      <Typography
                        data-test={"reports-group-item-firstname-title"}
                        variant="subtitle2"
                      >
                        {"First Name"}
                      </Typography>
                      <Typography
                        data-test={"reports-group-item-firstname-value"}
                        variant="body2"
                        style={{ color: "#616161" }}
                      >
                        {isNullOrEmpty(item.firstname) ? "-" : item.firstname}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography
                        data-test={"reports-group-item-surname-title"}
                        variant="subtitle2"
                      >
                        {"Surname"}
                      </Typography>
                      <Typography
                        data-test={"reports-group-item-surname-value"}
                        variant="body2"
                        style={{ color: "#616161" }}
                      >
                        {isNullOrEmpty(item.surname) ? "-" : item.surname}
                      </Typography>
                    </Grid>

                    <Grid item xs={3}>
                      <Typography
                        data-test={"reports-group-item-dob-title"}
                        variant="subtitle2"
                      >
                        {"D.O.B"}
                      </Typography>
                      <Typography
                        data-test={"reports-group-item-dob-value"}
                        variant="body2"
                        style={{ color: "#616161" }}
                      >
                        {isNullOrEmpty(item.dob)
                          ? "-"
                          : moment(item.dob).format("DD/MM/YYYY")}
                      </Typography>
                    </Grid>

                    <Grid item xs={3}>
                      <Typography
                        data-test={"reports-group-item-weight-title"}
                        variant="subtitle2"
                      >
                        {"Weight"}
                      </Typography>
                      <Typography
                        data-test={"reports-group-item-weight-value"}
                        variant="body2"
                        style={{ color: "#616161" }}
                      >
                        {isNullOrEmpty(item.latest_weight)
                          ? "-"
                          : item.latest_weight +
                            "kg (" +
                            moment(item.latest_weight_timestamp).format(
                              "DD/MM/YYYY HH:MM:ss"
                            ) +
                            ")"}
                      </Typography>
                    </Grid>

                    {isNEWSSelected && (
                      <Grid item xs={2}>
                        <Typography
                          data-test={"reports-group-item-news-title"}
                          variant="subtitle2"
                        >
                          {"NEWS"}
                        </Typography>
                        <Typography
                          data-test={"reports-group-item-news-value"}
                          variant="body2"
                          style={{ color: "#616161" }}
                        >
                          {isNullOrEmpty(item.latest_news_score)
                            ? "-"
                            : item.latest_news_score +
                              " (" +
                              moment(item.latest_news_score_timestamp).format(
                                "DD/MM/YYYY HH:MM:ss"
                              ) +
                              ")"}
                        </Typography>
                      </Grid>
                    )}
                    {isWaterlowSelected && (
                      <Grid item xs={2}>
                        <Typography
                          data-test={"reports-group-item-waterlow-title"}
                          variant="subtitle2"
                        >
                          {"Waterlow"}
                        </Typography>
                        <Typography
                          data-test={"reports-group-item-waterlow-value"}
                          variant="body2"
                          style={{ color: "#616161" }}
                        >
                          {isNullOrEmpty(item.latest_waterlow_score)
                            ? "-"
                            : item.latest_waterlow_score}
                        </Typography>
                      </Grid>
                    )}

                    {isMMSESelected && (
                      <Grid item xs={2}>
                        <Typography
                          data-test={"reports-group-item-mmse-title"}
                          variant="subtitle2"
                        >
                          {"MMSE"}
                        </Typography>
                        <Typography
                          data-test={"reports-group-item-mmse-value"}
                          variant="body2"
                          style={{ color: "#616161" }}
                        >
                          {isNullOrEmpty(item.latest_mmse_score)
                            ? "-"
                            : item.latest_mmse_score}
                        </Typography>
                      </Grid>
                    )}

                    {isFrailtySelected && (
                      <Grid item xs={2}>
                        <Typography
                          data-test={"reports-group-item-frailty-title"}
                          variant="subtitle2"
                        >
                          {"Frailty"}
                        </Typography>
                        <Typography
                          data-test={"reports-group-item-frailty-value"}
                          variant="body2"
                          style={{ color: "#616161" }}
                        >
                          {isNullOrEmpty(item.latest_frailty_score)
                            ? "-"
                            : item.latest_frailty_score}
                        </Typography>
                      </Grid>
                    )}

                    {isBarthelSelected && (
                      <Grid item xs={2}>
                        <Typography
                          data-test={"reports-group-item-barthel-title"}
                          variant="subtitle2"
                        >
                          {"Barthel"}
                        </Typography>
                        <Typography
                          data-test={"reports-group-item-barthel-value"}
                          variant="body2"
                          style={{ color: "#616161" }}
                        >
                          {isNullOrEmpty(item.latest_barthel_score)
                            ? "-"
                            : item.latest_barthel_score}
                        </Typography>
                      </Grid>
                    )}

                    {isMUSTSelected && (
                      <Grid item xs={2}>
                        <Typography
                          data-test={"reports-group-item-must-title"}
                          variant="subtitle2"
                        >
                          {"MUST"}
                        </Typography>
                        <Typography
                          data-test={"reports-group-item-must-value"}
                          variant="body2"
                          style={{ color: "#616161" }}
                        >
                          {isNullOrEmpty(item.latest_must_score)
                            ? "-"
                            : item.latest_must_score}
                        </Typography>
                      </Grid>
                    )}

                    {isNotesSelected && (
                      <Grid item xs={12}>
                        <Typography
                          data-test={"reports-group-item-notes-title"}
                          variant="subtitle2"
                        >
                          {"Notes"}
                        </Typography>
                        {JSON.parse(item.notes).length > 0 ? (
                          <ul>
                            {JSON.parse(item.notes)
                              .sort((a, b) => {
                                // Assuming plan_timestamp is a string in the format "YYYY-MM-DD HH:mm:ss"
                                const timestampA = moment(
                                  a.note_timestamp,
                                  "YYYY-MM-DD HH:mm:ss"
                                ).valueOf();
                                const timestampB = moment(
                                  b.note_timestamp,
                                  "YYYY-MM-DD HH:mm:ss"
                                ).valueOf();

                                return timestampB - timestampA; // Sort in descending order
                              })
                              .map((note) => (
                                <li key={note.note_id}>
                                  <Typography
                                    variant="body2"
                                    style={{ color: "#616161" }}
                                  >
                                    {`${moment(note.note_timestamp).format(
                                      "DD/MM/YYYY HH:mm:ss"
                                    )} by ${note.author} -  ${note.title} - ${
                                      note.log
                                    } `}
                                  </Typography>
                                </li>
                              ))}
                          </ul>
                        ) : (
                          <Typography
                            variant="body2"
                            style={{ color: "#616161" }}
                          >
                            {"-"}
                          </Typography>
                        )}
                      </Grid>
                    )}

                    {isPlansSelected && (
                      <Grid item xs={12}>
                        <Typography
                          data-test={"reports-group-item-plans-title"}
                          variant="subtitle2"
                        >
                          {"Plans"}
                        </Typography>
                        {JSON.parse(item.plans).length > 0 ? (
                          <ul>
                            {JSON.parse(item.plans)
                              .sort((a, b) => {
                                // Assuming plan_timestamp is a string in the format "YYYY-MM-DD HH:mm:ss"
                                const timestampA = moment(
                                  a.plan_timestamp,
                                  "YYYY-MM-DD HH:mm:ss"
                                ).valueOf();
                                const timestampB = moment(
                                  b.plan_timestamp,
                                  "YYYY-MM-DD HH:mm:ss"
                                ).valueOf();

                                return timestampB - timestampA; // Sort in descending order
                              })
                              .map((plan) => (
                                <li key={plan.plan_id}>
                                  <Typography
                                    variant="body2"
                                    style={{ color: "#616161" }}
                                  >
                                    {`${moment(plan.plan_timestamp).format(
                                      "DD/MM/YYYY HH:mm:ss"
                                    )} by ${plan.author} -  ${plan.title} - ${
                                      plan.log
                                    } `}
                                  </Typography>
                                </li>
                              ))}
                          </ul>
                        ) : (
                          <Typography
                            variant="body2"
                            style={{ color: "#616161" }}
                          >
                            {"-"}
                          </Typography>
                        )}
                      </Grid>
                    )}
                  </Grid>
                </Paper>
              </Grid>
            ))}
          </>
        ) : (
          <Typography
            data-test={"patient-notes-empty-msg"}
            style={{ textAlign: "center", padding: 20 }}
          >
            There is no data available.
          </Typography>
        )}
      </Grid>
    );
  };

  return (
    <Grid
      container
      spacing={1}
      style={{
        //display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {dataGrouped !== null && dataGrouped.length > 0 ? (
        <>
          {dataGrouped.map((dataItem) => (
            <Grid item xs={12} md={12} style={{ margin: 10 }}>
              <Typography
                data-test={"reports-group-title"}
                variant="h6"
                style={{}}
              >
                {dataItem.name} ({dataItem.patients.length}{" "}
                {dataItem.patients.length === 1 ? "patient" : "patients"})
              </Typography>
              <Divider
                orientation="horizontal"
                variant="fullWidth"
                style={{ padding: 2, marginBottom: 15 }}
              />
              <div
                style={{
                  //display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  //paddingTop: 40,
                  //pageBreakBefore: "always",
                }}
              >
                {generateListItem(dataItem.name, dataItem.patients)}
              </div>
            </Grid>
          ))}
        </>
      ) : (
        dataGrouped === null && (
          <Typography
            data-test={"reports-empty-msg"}
            style={{ textAlign: "center" }}
          >
            There is no data available for the selected ranges.
          </Typography>
        )
      )}
    </Grid>
  );
}
